
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M25 10v17.5H5V3.13h12.5"}}),_c('path',{attrs:{"stroke-width":"1.6","d":"M9.57 18.24L15.31 16l10.4-10.4a.92.92 0 000-1.3l-2.23-2.2a.92.92 0 00-1.3 0l-10.4 10.39z"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M24.6 6.75l-3.54-3.54M15.31 16.03l-3.53-3.54"}})])])
          )
        }
      }
    